<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{
              $route.params.id
                ? "View Flexible Work Arrangement"
                : "Apply Flexible Work Arrangement"
            }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form v-if="fwa" @submit.prevent="save">
      <!-- Employee Info -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-md-2 w-180">Employee Name/ID</div>
                <div class="col-md-4 pl-md-0">
                  {{ fwa.EmployeeName + " (" + fwa.EmployeeID + ")" }}
                </div>
                <div class="col-md-2 ml-md-4 w-180">Date of Application</div>
                <div class="col-md-3 pl-md-0">
                  {{ fwa.ApplicationDateDisplay }}
                </div>
              </div>

              <div class="row align-items-center mt-2">
                <div class="col-md-2 w-180">Position Title</div>
                <div class="col-md-4 pl-md-0">
                  {{ fwa.PositionTitle }}
                </div>
                <div class="col-md-2 ml-md-4 w-180">Organisation Unit</div>
                <div class="col-md-3 pl-md-0">{{ fwa.CostCenter }}</div>
              </div>

              <div class="row align-items-center mt-2">
                <div class="col-md-2 w-180">1st Level Approver</div>
                <div class="col-md-4 pl-md-0">
                  {{
                    fwa.FirstLevelApproverEmployeeName &&
                    fwa.FirstLevelApproverEmployeeID
                      ? fwa.FirstLevelApproverEmployeeName +
                        " (" +
                        fwa.FirstLevelApproverEmployeeID +
                        ")"
                      : ""
                  }}
                </div>
                <div class="col-md-2 ml-md-4 w-180">2nd Level Approver</div>
                <div class="col-md-3 pl-md-0">
                  {{
                    fwa.SecondLevelApproverEmployeeName &&
                    fwa.SecondLevelApproverEmployeeID
                      ? fwa.SecondLevelApproverEmployeeName +
                        " (" +
                        fwa.SecondLevelApproverEmployeeID +
                        ")"
                      : ""
                  }}
                </div>
              </div>

              <div class="row align-items-center mt-2" v-if="fwa.StatusText">
                <div class="col-md-2 w-180">Status</div>
                <div class="col-md-4 pl-md-0">{{ fwa.StatusText }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Employee Info -->

      <!-- Application -->
      <fieldset :disabled="isApplicationDisabled">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">Application</div>
              <div class="card-body">
                <!-- Type -->
                <div class="row align-items-center">
                  <div class="col-md-2 w-150">FWA Type</div>
                  <div class="col-md-4 pl-md-0 fit-content">
                    <select class="custom-select" v-model="fwa.Type" required>
                      <option value>-- Please Select --</option>
                      <option value="Flexi Place">Flexi Place</option>
                      <option value="Flexi Time">Flexi Time</option>
                    </select>
                  </div>
                </div>
                <!-- /Type -->

                <!-- Start Date and End Date -->
                <div class="row align-items-center mt-3" v-if="fwa.Type">
                  <div class="col-md-2 w-150">FWA Start Date</div>
                  <div class="col-md-2 pl-md-0 fit-content">
                    <input
                      type="date"
                      class="form-control"
                      v-model="fwa.StartDateCal"
                      required
                    />
                  </div>
                  <div class="col-md-2 ml-md-3 w-140">FWA End Date</div>
                  <div class="col-md-2 pl-md-0 fit-content">
                    <input
                      type="date"
                      class="form-control"
                      v-model="fwa.EndDateCal"
                      :min="fwa.StartDateCal"
                      required
                    />
                  </div>
                  <div class="col-md-2 ml-md-3 fit-content">
                    Total FWA Duration
                  </div>
                  <div class="col-md-1 pl-md-0">{{ fwa.Duration }} day(s)</div>
                </div>
                <!-- /Start Date and End Date -->

                <!-- Occurrence Per Week and Impacted Days-->
                <div
                  class="row align-items-center mt-3"
                  v-if="fwa.Type == 'Flexi Place'"
                >
                  <div class="col-md-2 fit-content">Occurrence Per Week</div>
                  <div class="col-md-1 pl-md-0 fit-content">
                    <select
                      class="custom-select"
                      v-model="fwa.OccurrencePerWeek"
                      required
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                    </select>
                  </div>
                  <div class="col-md-2 ml-82 fit-content">Impacted Days</div>
                  <div class="col-md-6 pl-md-0 impacted-days-div">
                    <input
                      type="checkbox"
                      id="chkMonday"
                      value="Monday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label class="mr-md-2" for="chkMonday">Monday</label>
                    <input
                      type="checkbox"
                      id="chkTuesday"
                      value="Tuesday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label class="mr-md-2" for="chkTuesday">Tuesday</label>
                    <input
                      type="checkbox"
                      id="chkWednesday"
                      value="Wednesday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label class="mr-md-2" for="chkWednesday">Wednesday</label>
                    <input
                      type="checkbox"
                      id="chkThursday"
                      value="Thursday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label class="mr-md-2" for="chkThursday">Thursday</label>
                    <input
                      type="checkbox"
                      id="chkFriday"
                      value="Friday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label class="mr-md-2" for="chkFriday">Friday</label>
                    <input
                      type="checkbox"
                      id="chkSaturday"
                      value="Saturday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label class="mr-md-2" for="chkSaturday">
                      Saturday (For Shift Only)
                    </label>
                    <input
                      type="checkbox"
                      id="chkSunday"
                      value="Sunday"
                      v-model="fwa.ImpactedDays"
                    />
                    <label for="chkSunday">Sunday (For Shift Only)</label>
                  </div>
                </div>
                <!-- /Occurrence Per Week and Impacted Days-->

                <!-- Location -->
                <div
                  class="row align-items-center mt-3"
                  v-if="fwa.Type == 'Flexi Place'"
                >
                  <div class="col-md-12">
                    Location (<span class="text-danger">*</span>This is a
                    mandatory field.)
                  </div>
                </div>
                <div
                  class="row align-items-center"
                  v-if="fwa.Type == 'Flexi Place'"
                >
                  <div class="col-md-10">
                    <textarea
                      class="form-control"
                      rows="5"
                      maxlength="1000"
                      v-model="fwa.Location"
                      required
                    ></textarea>
                  </div>
                </div>
                <!-- /Location -->

                <!-- Start Time and End Time -->
                <div
                  class="row align-items-center mt-3"
                  v-if="fwa.Type == 'Flexi Time'"
                >
                  <div class="col-md-2 w-190">Work Day Start Time</div>
                  <div class="col-md-2 pl-md-0 fit-content">
                    <select
                      class="custom-select"
                      v-model="fwa.StartTime"
                      required
                    >
                      <option v-for="time in times" :key="time">
                        {{ time }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-2 ml-45 w-180">Work Day End Time</div>
                  <div class="col-md-2 pl-md-0 fit-content">
                    <select
                      class="custom-select"
                      v-model="fwa.EndTime"
                      required
                    >
                      <option v-for="time in times" :key="time">
                        {{ time }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4 ml-45 fit-content">
                    Total Working Hours should add up to 9 Hours, Including 1
                    Hour Break
                  </div>
                  <div class="col-md-2 p-0 fit-content">
                    {{ fwa.WorkingHours }} hour(s)
                  </div>
                </div>
                <!-- /Start Time and End Time -->

                <!-- Reason -->
                <div class="row align-items-center mt-3" v-if="fwa.Type">
                  <div class="col-md-12">
                    A) Please indicate your reasons for applying for
                    {{ fwa.Type }} FWA (<span class="text-danger">*</span>This
                    is a mandatory field.)
                  </div>
                </div>
                <div class="row align-items-center" v-if="fwa.Type">
                  <div class="col-md-10">
                    <textarea
                      class="form-control"
                      rows="5"
                      maxlength="1000"
                      v-model="fwa.Reason"
                      required
                    ></textarea>
                  </div>
                </div>
                <!-- /Reason -->

                <!-- Affected Job -->
                <div class="row align-items-center mt-3" v-if="fwa.Type">
                  <div class="col-md-12">
                    B) Please indicate the foreseeable day-to-day job
                    responsibilities that would be affected by your
                    {{ fwa.Type }} FWA (<span class="text-danger">*</span>This
                    is a mandatory field.)
                  </div>
                </div>
                <div class="row align-items-center" v-if="fwa.Type">
                  <div class="col-md-10">
                    <textarea
                      class="form-control"
                      rows="5"
                      maxlength="1000"
                      v-model="fwa.AffectedJob"
                      required
                    ></textarea>
                  </div>
                </div>
                <!-- /Affected Job -->

                <!-- Proposal -->
                <div class="row align-items-center mt-3" v-if="fwa.Type">
                  <div class="col-md-12">
                    C) As per your answer in part b, please indicate your
                    proposal on how the impact can be managed (<span
                      class="text-danger"
                      >*</span
                    >This is a mandatory field.)
                  </div>
                </div>
                <div class="row align-items-center" v-if="fwa.Type">
                  <div class="col-md-10">
                    <textarea
                      class="form-control"
                      rows="5"
                      maxlength="1000"
                      v-model="fwa.Proposal"
                      required
                    ></textarea>
                  </div>
                </div>
                <!-- /Proposal -->

                <!-- Guideline Acknowledgement -->
                <div class="row align-items-center mt-3" v-if="fwa.Type">
                  <div class="col-md-12 guideline-div">
                    <input
                      type="checkbox"
                      id="chkGuidelineAck"
                      v-model="fwa.IsGuidelineAcknowledged"
                      required
                    />
                    <label for="chkGuidelineAck">
                      I acknowledge that I have read through the enclosed FWA
                      guidelines and will adhere to the instructions accordingly
                    </label>
                  </div>
                </div>
                <!-- /Guideline Acknowledgement -->

                <!-- Definition Acknowledgement -->
                <div
                  class="row align-items-center mt-3"
                  v-if="fwa.Type == 'Flexi Place'"
                >
                  <div class="col-md-12 definition-div">
                    <input
                      type="checkbox"
                      id="chkDefinitionAck"
                      v-model="fwa.IsDefinitionAcknowledged"
                      required
                    />
                    <label for="chkDefinitionAck">
                      I acknowledge that the definition of Work from "Home"
                      still refers to working in Singapore (payroll country)
                    </label>
                  </div>
                </div>
                <!-- /Definition Acknowledgement -->
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- /Application -->

      <!-- First Level Approval -->
      <fieldset
        v-if="isFirstLevelApprovalShown"
        :disabled="isFirstLevelApprovalDisabled"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">1st Level Approval</div>
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col-md-10 firstlevelapproval-div">
                    <input
                      type="radio"
                      id="radio_1stLevelApprove"
                      name="1st Level Approval"
                      v-model="fwa.FirstLevelApprovalAction"
                      value="Approve"
                      required
                    />
                    <label class="mr-4" for="radio_1stLevelApprove">
                      Approve
                    </label>
                    <input
                      type="radio"
                      id="radio_1stLevelReject"
                      name="1st Level Approval"
                      v-model="fwa.FirstLevelApprovalAction"
                      value="Reject"
                      required
                    />
                    <label for="radio_1stLevelReject">Reject</label>
                  </div>
                </div>
                <template v-if="fwa.FirstLevelApprovalAction == 'Approve'">
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for approving your team
                      member's FWA request (<span class="text-danger">*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="fwa.FirstLevelApprovalJustification"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please indicate aligned expectations of work deliverables
                      whilst team member is on FWA (<span class="text-danger"
                        >*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="fwa.WorkExpectation"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12 replacement-div">
                      <input
                        type="checkbox"
                        id="chkReplacementAck"
                        v-model="fwa.IsReplacementInabilityAcknowledged"
                        required
                      />
                      <label for="chkReplacementAck">
                        I acknowledge that I'm not able to request for
                        replacement headcount whilst my team member is on
                        approved FWA
                      </label>
                    </div>
                  </div>
                </template>
                <template v-if="fwa.FirstLevelApprovalAction == 'Reject'">
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for rejecting your team
                      member's FWA request (<span class="text-danger">*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="fwa.FirstLevelRejectionJustification"
                        required
                      ></textarea>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- /First Level Approval -->

      <!-- Second Level Approval -->
      <fieldset
        v-if="isSecondLevelApprovalShown"
        :disabled="isSecondLevelApprovalDisabled"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">2nd Level Approval</div>
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col-md-10 secondlevelapproval-div">
                    <input
                      type="radio"
                      id="radio_2ndLevelApprove"
                      name="2nd Level Approval"
                      v-model="fwa.SecondLevelApprovalAction"
                      value="Approve"
                      required
                    />
                    <label class="mr-4" for="radio_2ndLevelApprove">
                      Approve
                    </label>
                    <input
                      type="radio"
                      id="radio_2ndLevelReject"
                      name="2nd Level Approval"
                      v-model="fwa.SecondLevelApprovalAction"
                      value="Reject"
                      required
                    />
                    <label for="radio_2ndLevelReject">Reject</label>
                  </div>
                </div>
                <template v-if="fwa.SecondLevelApprovalAction == 'Approve'">
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for approving your team
                      member's FWA request (<span class="text-danger">*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="fwa.SecondLevelApprovalJustification"
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12 decision-div">
                      <input
                        type="checkbox"
                        id="chkDecisionAck"
                        v-model="fwa.IsDecisionAcknowledged"
                        required
                      />
                      <label for="chkDecisionAck">
                        I acknowledge that I'm aligned with the decision to
                        place this team member on FWA arrangement as per the
                        agreed duration
                      </label>
                    </div>
                  </div>
                </template>
                <template v-if="fwa.SecondLevelApprovalAction == 'Reject'">
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for rejecting your team
                      member's FWA request (<span class="text-danger">*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="fwa.SecondLevelRejectionJustification"
                        required
                      ></textarea>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- /Second Level Approval -->

      <!-- First Level Cancelation Approval -->
      <fieldset
        v-if="isFirstLevelCancelationApprovalShown"
        :disabled="isFirstLevelCancelationApprovalDisabled"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">1st Level Cancellation Approval</div>
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col-md-10 firstlevelapproval-div">
                    <input
                      type="radio"
                      id="radio_1stLevelCancelationApprove"
                      name="1st Level Cancelation Approval"
                      v-model="fwa.FirstLevelCancelationApprovalAction"
                      value="Approve"
                      required
                    />
                    <label class="mr-4" for="radio_1stLevelCancelationApprove">
                      Approve
                    </label>
                    <input
                      type="radio"
                      id="radio_1stLevelCancelationReject"
                      name="1st Level Cancelation Approval"
                      v-model="fwa.FirstLevelCancelationApprovalAction"
                      value="Reject"
                      required
                    />
                    <label for="radio_1stLevelCancelationReject">Reject</label>
                  </div>
                </div>
                <template
                  v-if="fwa.FirstLevelCancelationApprovalAction == 'Approve'"
                >
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for approving your team
                      member's FWA cancellation request (<span
                        class="text-danger"
                        >*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="fwa.FirstLevelCancelationApprovalJustification"
                        required
                      ></textarea>
                    </div>
                  </div>
                </template>
                <template
                  v-if="fwa.FirstLevelCancelationApprovalAction == 'Reject'"
                >
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for rejecting your team
                      member's FWA cancellation request (<span
                        class="text-danger"
                        >*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="
                          fwa.FirstLevelCancelationRejectionJustification
                        "
                        required
                      ></textarea>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- /First Level Cancelation Approval -->

      <!-- Second Level Cancelation Approval -->
      <fieldset
        v-if="isSecondLevelCancelationApprovalShown"
        :disabled="isSecondLevelCancelationApprovalDisabled"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">2nd Level Cancellation Approval</div>
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col-md-10 secondlevelapproval-div">
                    <input
                      type="radio"
                      id="radio_2ndLevelCancelationApprove"
                      name="2nd Level Cancelation Approval"
                      v-model="fwa.SecondLevelCancelationApprovalAction"
                      value="Approve"
                      required
                    />
                    <label class="mr-4" for="radio_2ndLevelCancelationApprove">
                      Approve
                    </label>
                    <input
                      type="radio"
                      id="radio_2ndLevelCancelationReject"
                      name="2nd Level Cancelation Approval"
                      v-model="fwa.SecondLevelCancelationApprovalAction"
                      value="Reject"
                      required
                    />
                    <label for="radio_2ndLevelCancelationReject">Reject</label>
                  </div>
                </div>
                <template
                  v-if="fwa.SecondLevelCancelationApprovalAction == 'Approve'"
                >
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for approving your team
                      member's FWA cancellation request (<span
                        class="text-danger"
                        >*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="
                          fwa.SecondLevelCancelationApprovalJustification
                        "
                        required
                      ></textarea>
                    </div>
                  </div>
                </template>
                <template
                  v-if="fwa.SecondLevelCancelationApprovalAction == 'Reject'"
                >
                  <div class="row align-items-center mt-3">
                    <div class="col-md-12">
                      Please provide justification for rejecting your team
                      member's FWA cancellation request (<span
                        class="text-danger"
                        >*</span
                      >This is a mandatory field.)
                    </div>
                  </div>
                  <div class="row align-items-center">
                    <div class="col-md-10">
                      <textarea
                        class="form-control"
                        rows="5"
                        maxlength="1000"
                        v-model="
                          fwa.SecondLevelCancelationRejectionJustification
                        "
                        required
                      ></textarea>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <!-- /Second Level Cancelation Approval -->

      <!-- Buttons -->
      <div class="row mb-4">
        <div class="col-md-4">
          <button
            v-if="$route.params.id && $store.state.fwaSourcePage"
            type="button"
            class="btn btn-secondary"
            @click="$router.go(-1)"
          >
            <i class="fa fa-reply mr-1"></i>Back
          </button>
        </div>
        <div class="col-md-8 text-right">
          <button
            v-if="isChangeButtonShown"
            type="button"
            class="btn btn-secondary"
            @click="isChange = true"
          >
            <i class="fa fa-edit mr-1"></i>Change
          </button>
          <button
            v-if="isSubmitButtonShown"
            type="submit"
            class="btn btn-primary"
            :disabled="!fwa.Type"
          >
            <i class="fa fa-play mr-1"></i>Submit
          </button>
          <template v-if="isChange">
            <button type="button" class="btn btn-secondary" @click="cancel">
              <i class="fa fa-window-close-o mr-1"></i>Cancel
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="fa fa-save mr-1"></i>Save
            </button>
          </template>
        </div>
      </div>
      <!-- /Buttons -->
    </form>
    <!-- /Form -->
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      fwa: null,
      isChange: false,
    };
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
    employeeID() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.EmployeeID;
    },
    days() {
      let days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days;
    },
    times() {
      let times = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 30) {
          const formattedHour = String(hour).padStart(2, "0");
          const formattedMinute = String(minute).padStart(2, "0");
          times.push(`${formattedHour}:${formattedMinute}`);
        }
      }
      return times;
    },
    isApplicationDisabled() {
      return this.fwa.Status && !this.isChange;
    },
    isFirstLevelApprovalDisabled() {
      let isFirstLevelApprovalEnabled =
        (this.role == "admin" ||
          this.employeeID == this.fwa.FirstLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 1st Level Approval";
      return !isFirstLevelApprovalEnabled;
    },
    isFirstLevelApprovalShown() {
      let condition1 =
        (this.role == "admin" ||
          this.employeeID == this.fwa.FirstLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 1st Level Approval";
      let condition2 =
        this.fwa.StatusDetail == "Pending 2nd Level Approval" ||
        this.fwa.Status == "Approved" ||
        this.fwa.Status == "Rejected" ||
        this.fwa.Status == "Pending Cancellation" ||
        this.fwa.Status == "Cancelled";
      let condition3 =
        this.fwa.Status == "Withdrawn" &&
        this.fwa.FirstLevelApprovalAction == "Approve";
      return condition1 || condition2 || condition3;
    },
    isSecondLevelApprovalDisabled() {
      let isSecondLevelApprovalEnabled =
        (this.role == "admin" ||
          this.employeeID == this.fwa.SecondLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 2nd Level Approval";
      return !isSecondLevelApprovalEnabled;
    },
    isSecondLevelApprovalShown() {
      let condition1 =
        (this.role == "admin" ||
          this.employeeID == this.fwa.SecondLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 2nd Level Approval";
      let condition2 =
        this.fwa.Status == "Approved" ||
        this.fwa.Status == "Pending Cancellation" ||
        this.fwa.Status == "Cancelled";
      let condition3 =
        this.fwa.Status == "Rejected" &&
        this.fwa.SecondLevelApprovalAction == "Reject";
      return condition1 || condition2 || condition3;
    },
    isFirstLevelCancelationApprovalDisabled() {
      let isFirstLevelCancelationApprovalEnabled =
        (this.role == "admin" ||
          this.employeeID == this.fwa.FirstLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 1st Level Cancellation Approval";
      return !isFirstLevelCancelationApprovalEnabled;
    },
    isFirstLevelCancelationApprovalShown() {
      let condition1 =
        (this.role == "admin" ||
          this.employeeID == this.fwa.FirstLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 1st Level Cancellation Approval";
      let condition2 =
        this.fwa.StatusDetail == "Pending 2nd Level Cancellation Approval" ||
        this.fwa.Status == "Cancelled";
      let condition3 =
        this.fwa.Status == "Approved" &&
        this.fwa.FirstLevelCancelationApprovalAction == "Reject";
      return condition1 || condition2 || condition3;
    },
    isSecondLevelCancelationApprovalDisabled() {
      let isSecondLevelCancelationApprovalEnabled =
        (this.role == "admin" ||
          this.employeeID == this.fwa.SecondLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 2nd Level Cancellation Approval";
      return !isSecondLevelCancelationApprovalEnabled;
    },
    isSecondLevelCancelationApprovalShown() {
      let condition1 =
        (this.role == "admin" ||
          this.employeeID == this.fwa.SecondLevelApproverEmployeeID) &&
        this.fwa.StatusDetail == "Pending 2nd Level Cancellation Approval";
      let condition2 = this.fwa.Status == "Cancelled";
      let condition3 =
        this.fwa.Status == "Approved" &&
        this.fwa.SecondLevelCancelationApprovalAction == "Reject";
      return condition1 || condition2 || condition3;
    },
    isChangeButtonShown() {
      return (
        this.role == "admin" && this.fwa.Status == "Approved" && !this.isChange
      );
    },
    isSubmitButtonShown() {
      let condition1 = this.role == "employee" && !this.fwa.Status;
      let condition2 =
        this.role == "admin" &&
        (this.fwa.Status == "Pending Approval" ||
          this.fwa.Status == "Pending Cancellation");
      let condition3 =
        this.employeeID == this.fwa.FirstLevelApproverEmployeeID &&
        (this.fwa.StatusDetail == "Pending 1st Level Approval" ||
          this.fwa.StatusDetail == "Pending 1st Level Cancellation Approval");
      let condition4 =
        this.employeeID == this.fwa.SecondLevelApproverEmployeeID &&
        (this.fwa.StatusDetail == "Pending 2nd Level Approval" ||
          this.fwa.StatusDetail == "Pending 2nd Level Cancellation Approval");
      return condition1 || condition2 || condition3 || condition4;
    },
    action() {
      let action = "";
      let currentStatusDetail = this.fwa.StatusDetail;
      let firstLevelApprovalAction = this.fwa.FirstLevelApprovalAction;
      let secondLevelApprovalAction = this.fwa.SecondLevelApprovalAction;
      let firstLevelCancelationApprovalAction =
        this.fwa.FirstLevelCancelationApprovalAction;
      let secondLevelCancelationApprovalAction =
        this.fwa.SecondLevelCancelationApprovalAction;
      if (!currentStatusDetail) {
        action = "Apply";
      } else if (currentStatusDetail == "Pending 1st Level Approval") {
        if (firstLevelApprovalAction == "Approve") action = "1st Level Approve";
        else if (firstLevelApprovalAction == "Reject")
          action = "1st Level Reject";
      } else if (currentStatusDetail == "Pending 2nd Level Approval") {
        if (secondLevelApprovalAction == "Approve")
          action = "2nd Level Approve";
        else if (secondLevelApprovalAction == "Reject")
          action = "2nd Level Reject";
      } else if (
        currentStatusDetail == "Pending 1st Level Cancellation Approval"
      ) {
        if (firstLevelCancelationApprovalAction == "Approve")
          action = "1st Level Cancellation Approve";
        else if (firstLevelCancelationApprovalAction == "Reject")
          action = "1st Level Cancellation Reject";
      } else if (
        currentStatusDetail == "Pending 2nd Level Cancellation Approval"
      ) {
        if (secondLevelCancelationApprovalAction == "Approve")
          action = "2nd Level Cancellation Approve";
        else if (secondLevelCancelationApprovalAction == "Reject")
          action = "2nd Level Cancellation Reject";
      } else if (this.role == "admin" && currentStatusDetail == "Approved") {
        action = "Change";
      }
      return action;
    },
  },
  watch: {
    "fwa.StartDateCal": function (val) {
      if (!val || !this.fwa.EndDateCal) {
        this.fwa.Duration = 0;
        return;
      }
      let startDate = new Date(val);
      let endDate = new Date(this.fwa.EndDateCal);
      this.fwa.Duration = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
    },
    "fwa.EndDateCal": function (val) {
      if (!val || !this.fwa.StartDateCal) {
        this.fwa.Duration = 0;
        return;
      }
      let startDate = new Date(this.fwa.StartDateCal);
      let endDate = new Date(val);
      this.fwa.Duration = (endDate - startDate) / (1000 * 60 * 60 * 24) + 1;
    },
    "fwa.StartTime": function (val) {
      if (!val || !this.fwa.EndTime) {
        this.fwa.WorkingHours = 0;
        return;
      }
      let [startHour, startMinute] = val.split(":").map(Number);
      let [endHour, endMinute] = this.fwa.EndTime.split(":").map(Number);
      let startTotalMinutes = startHour * 60 + startMinute;
      let endTotalMinutes = endHour * 60 + endMinute;
      if (endTotalMinutes < startTotalMinutes) endTotalMinutes += 24 * 60;
      let differenceInMinutes = endTotalMinutes - startTotalMinutes;
      this.fwa.WorkingHours = differenceInMinutes / 60;
    },
    "fwa.EndTime": function (val) {
      if (!val || !this.fwa.StartTime) {
        this.fwa.WorkingHours = 0;
        return;
      }
      let [startHour, startMinute] = this.fwa.StartTime.split(":").map(Number);
      let [endHour, endMinute] = val.split(":").map(Number);
      let startTotalMinutes = startHour * 60 + startMinute;
      let endTotalMinutes = endHour * 60 + endMinute;
      if (endTotalMinutes < startTotalMinutes) endTotalMinutes += 24 * 60;
      let differenceInMinutes = endTotalMinutes - startTotalMinutes;
      this.fwa.WorkingHours = differenceInMinutes / 60;
    },
    "$route.params.id": function (val) {
      this.getFwaDetail();
    },
  },
  methods: {
    cancel() {
      this.isChange = false;
      this.getFwaDetail();
    },
    getFwaDetail() {
      let param = { Token: this.token, Id: this.$route.params.id };
      this.$store.state.isLoading = true;
      API.getFwaDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.fwa = response.data.record;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      this.fwa.Action = this.action;
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        Fwa: this.fwa,
      };
      API.validateFwaSubmission(param)
        .then((response) => {
          if (response.data.success) this.submit();
          else alert(response.data.message);
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    submit() {
      let confirmationText = "";
      if (this.action == "Apply")
        confirmationText = "Are you sure you want to submit the application?";
      else if (
        this.action == "1st Level Approve" ||
        this.action == "2nd Level Approve"
      )
        confirmationText = "Are you sure you want to approve the application?";
      else if (
        this.action == "1st Level Reject" ||
        this.action == "2nd Level Reject"
      )
        confirmationText = "Are you sure you want to reject the application?";
      else if (
        this.action == "1st Level Cancellation Approve" ||
        this.action == "2nd Level Cancellation Approve"
      )
        confirmationText =
          "Are you sure you want to approve the cancellation request?";
      else if (
        this.action == "1st Level Cancellation Reject" ||
        this.action == "2nd Level Cancellation Reject"
      )
        confirmationText =
          "Are you sure you want to reject the cancellation request?";
      else if (this.action == "Change")
        confirmationText = "Are you sure you want to modify the application?";

      this.fwa.Action = this.action;
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        Fwa: this.fwa,
      };
      this.$swal({
        title: "Are you sure?",
        text: confirmationText,
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.submitFwa(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                if (!this.$route.params.id)
                  this.$router.replace({
                    name: "fwaView",
                    params: { id: response.data.fwaId },
                  });
                else this.getFwaDetail();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },
  created() {
    this.getFwaDetail();
  },
};
</script>

<style scoped>
.fit-content {
  max-width: fit-content;
}
.w-150 {
  max-width: 150px;
}
.w-140 {
  max-width: 140px;
}
.w-180 {
  max-width: 180px;
}
.w-190 {
  max-width: 190px;
}
.ml-45 {
  margin-left: 45px;
}
.ml-82 {
  margin-left: 82px;
}
.impacted-days-div {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: 450px;
  line-height: 25px;
}
.impacted-days-div label {
  margin-bottom: -0.2rem;
  cursor: pointer;
  word-spacing: -3px;
}
.impacted-days-div input[type="checkbox"] {
  margin-right: 3px;
  cursor: pointer;
}

.guideline-div,
.definition-div,
.firstlevelapproval-div,
.replacement-div,
.secondlevelapproval-div,
.decision-div {
  display: flex;
  align-items: center;
}
.guideline-div label,
.definition-div label,
.firstlevelapproval-div label,
.replacement-div label,
.secondlevelapproval-div label,
.decision-div label {
  margin-bottom: -0.2rem;
  cursor: pointer;
  word-spacing: -3px;
}
.guideline-div input[type="checkbox"],
.definition-div input[type="checkbox"],
.replacement-div input[type="checkbox"],
.decision-div input[type="checkbox"] {
  margin-right: 10px;
  cursor: pointer;
}
.firstlevelapproval-div input[type="radio"],
.secondlevelapproval-div input[type="radio"] {
  margin-right: 5px;
  cursor: pointer;
}
.card-header {
  background-color: #e9ecef;
  text-align: center;
  font-weight: 500;
  font-size: 20px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.custom-select:disabled {
  color: #1f1f1f;
}
@media only screen and (max-width: 1400px) {
  .ml-45 {
    margin-left: 10px !important;
    word-spacing: -2px !important;
  }
}
@media only screen and (max-width: 1300px) {
  .card-body,
  .card-body select,
  .card-body input,
  .card-body textarea {
    font-size: 13px;
  }
  .impacted-days-div {
    max-width: 400px;
  }
  .card-body input[type="date"] {
    height: 35px;
  }
  .ml-45 {
    margin-left: 10px !important;
    word-spacing: -2px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Fwa/FwaForm.vue